<script>
	import Footer from '$lib/components/Footer.svelte';
	import Navbar from '$lib/components/Navbar.svelte';
	import PageTransition from '$lib/components/PageTransition.svelte';
	import { basketListnew, basketId } from '$lib/store/newbasket';
	import { tgbot } from '$lib/store/telegrappapp';
	export let data;
	import '../../app.css';
	import { navigating, page } from '$app/stores';
	// import NProgress from 'nprogress';
	// import 'nprogress/nprogress.css';
	import { onMount } from 'svelte';
	import { variables } from '$lib/variables';
	import { goto } from '$app/navigation';
	import { browser } from '$app/environment';
	import { invalidateAll } from '$app/navigation';
	import FormCookie from '$lib/components/FormCookie.svelte';
	import { tweened } from 'svelte/motion';
	import { cubicOut } from 'svelte/easing';
	import BottomNav from '$lib/components/BottomNav.svelte';

	// Создаем tweened store для плавной анимации значения
	const progress = tweened(0, {
		duration: 2000, // Продолжительность анимации в миллисекундах
		easing: cubicOut // Функция плавности
	});
	if ($page.data.basketid) {
		$basketListnew = $page.data.basketid;
		$basketId = $page.data.basketid.id;
	}
	let interval;
	$: if ($navigating) {
		SetProgress();
	} else {
		clearInterval(interval);
		progress.set(1).then(() => {
			// Добавьте небольшую задержку перед сбросом, чтобы пользователь увидел 100%
			setTimeout(() => {
				progress.set(0);
				// Снова проверяем наличие progressBar перед изменением стиля
				progress.set(0);
			}, 1000);
		});
	}
	const SetProgress = () => {
		clearInterval(interval);

		// progress.set(0.25);
		// progress.set(0.5);
		// progress.set(0.75);
		// progress.set(1);
		progress.set(0.25); // Начальное значение при начале навигации
		interval = setInterval(() => {
			progress.update((n) => (n >= 0.9 ? n : n + 0.1)); // Медленно увеличиваем, но не доходим до 100%
		}, 100);
	};

	let userData = {};
	function addPathBackButton() {
		if (browser) {
			if ($tgbot) {
				if (window.history.length > 1 && window.location.pathname !== '/') {
					$tgbot.BackButton.isVisible = true;
					$tgbot.BackButton.show();
					$tgbot.onEvent('backButtonClicked', gotofunc);
				} else {
					$tgbot.BackButton.isVisible = false;
					$tgbot.BackButton.hide();
				}
			}
		}
	}

	// Реактивно отслеживаем состояние навигации 4
	$: if ($navigating) {
		progress.set(100); // Немедленно начинаем анимацию до 100%
	} else {
		// Дожидаемся завершения анимации, прежде чем сбросить прогресс
		completeAnimation().then(() => progress.set(0));
	}

	// Функция для ожидания завершения анимации
	async function completeAnimation() {
		await new Promise((resolve) => setTimeout(resolve, 500)); // Задержка должна соответствовать длительности анимации
	}

	async function SendTgData(params) {
		let url = `${variables.basePathApi}/users/users/telegram/`;
		const res = await fetch(url, {
			method: 'POST',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(params)
		});
		if (res.status == 200) {
		} else {
		}
	}
	let canGoBack = false;
	async function gotofunc() {
		window.history.back();
	}
	async function GetBasket() {
		let urls = `${variables.basePathApi}/api/v1/orders/user-auth/`;
		const res = await fetch(urls, {});
		if (res.status === 200) {
			return await res.json();
		}
		return null;
	}
	let closecookie = false;
	let latitude = null;
	let longitude = null;
	const GetCity = async () => {
		let url = `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}`;
		const res = await fetch(url);
		if (res.status === 200) {
			let resData = await res.json();

			localStorage.setItem('geoDataLocation', JSON.stringify(resData.address));
		} else {
		}
	};
	const getLocation = () => {
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition((position) => {
				latitude = position.coords.latitude;
				longitude = position.coords.longitude;

				GetCity();
			});
		} else {
			console.error('Geolocation is not supported by this browser.');
		}
	};
	onMount(async () => {
		// if (!localStorage.getItem('geoDataLocation')) {
		// 	getLocation();
		// }
		// ?referral_code=b52381c77c
		if ('serviceWorker' in navigator) {
			addEventListener('load', function () {
				navigator.serviceWorker
					.register('/service-worker.js')
					.catch((error) => console.error('Service Worker registration failed:', error));
			});
		}
		if ($page.url.searchParams.get('referral_code')) {
			localStorage.setItem('referral_code', String($page.url.searchParams.get('referral_code')));
		}
		if ($page.data.basketid) {
			$basketListnew = $page.data.basketid;
			$basketId = $page.data.basketid.id;
		}
		if (!localStorage.getItem('closecookie')) {
			closecookie = true;
		}

		// await SendTgData(test.user);
		$tgbot = window.Telegram.WebApp;

		if ($tgbot.initData) {
			let queryDict = {};

			$tgbot.setHeaderColor('#1b1b1b');
			$tgbot.MainButton.isVisible = true;
			$tgbot.MainButton.text = 'Корзина';
			$tgbot.MainButton.color = '#bfbcbc';
			$tgbot.initData.split('&').forEach(function (part) {
				let [key, value] = part.split('=');

				// Декодирование JSON-объекта, если это необходимо
				if (key === 'user') {
					value = JSON.parse(decodeURIComponent(value));
				}

				queryDict[key] = value;
			});
			userData = queryDict;
			if (userData) {
				try {
					await SendTgData(userData.user);
				} catch (error) {}
			}
		}
	});
</script>

<svelte:head>
	<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css" />

	<script src="https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js"></script>
</svelte:head>
<div class="app overflow-hidden">
	<!-- {#if closecookie}
		<FormCookie bind:closecookie />
	{/if} -->
	<a
		target="_blank"
		href="tg://resolve?phone=79647135054"
		type="button"
		data-te-ripple-init
		data-te-ripple-color="light"
		class="mb-2 btn-call rounded-full shadow-2xl inline-block fixed right-8 z-30 px-2 py-2 text-xs font-medium uppercase leading-normal text-white transition duration-150 ease-in-out hover:shadow-lg focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg"
		style="background-color:  #0088cc;bottom: 15em;"
	>
		<svg
			class="h-6 w-6"
			fill="currentColor"
			viewbox="0 0 24 24"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
			xml:space="preserve"
			xmlns:serif="http://www.serif.com/"
			style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;"
		>
			<path
				id="telegram-1"
				d="M18.384,22.779c0.322,0.228 0.737,0.285 1.107,0.145c0.37,-0.141 0.642,-0.457 0.724,-0.84c0.869,-4.084 2.977,-14.421 3.768,-18.136c0.06,-0.28 -0.04,-0.571 -0.26,-0.758c-0.22,-0.187 -0.525,-0.241 -0.797,-0.14c-4.193,1.552 -17.106,6.397 -22.384,8.35c-0.335,0.124 -0.553,0.446 -0.542,0.799c0.012,0.354 0.25,0.661 0.593,0.764c2.367,0.708 5.474,1.693 5.474,1.693c0,0 1.452,4.385 2.209,6.615c0.095,0.28 0.314,0.5 0.603,0.576c0.288,0.075 0.596,-0.004 0.811,-0.207c1.216,-1.148 3.096,-2.923 3.096,-2.923c0,0 3.572,2.619 5.598,4.062Zm-11.01,-8.677l1.679,5.538l0.373,-3.507c0,0 6.487,-5.851 10.185,-9.186c0.108,-0.098 0.123,-0.262 0.033,-0.377c-0.089,-0.115 -0.253,-0.142 -0.376,-0.064c-4.286,2.737 -11.894,7.596 -11.894,7.596Z"
			/>
		</svg>
	</a>
	<Navbar />
	<main class="">
		{#if $navigating}
			<div
				style="z-index: 10000;"
				class="fixed top-0 left-0 w-full bg-gray-200 rounded-full h-1 mb-4 dark:bg-gray-700"
			>
				<div class="bg-red-600 h-1 rounded-full dark:bg-indigo-500" style="width: {$progress}%" />
			</div>
		{/if}
		<slot />
	</main>

	{#if !$tgbot?.initData}
	{#if !$page.url.pathname.includes('/cart')}
		<div class="md:hidden block">
			<BottomNav />
		</div>
		{/if}
	{/if}
{#if !$page.url.pathname.includes('/cart')}
	<footer class="">
		{#if !$page.url.pathname.includes('/auth')}
			<Footer />
		{/if}
	</footer>
	{/if}
</div>

<style>
	.app {
		background-color: #ffffff;
	}

	.btn-call {
		background: #38a3fd;
		border: 2px solid #38a3fd;
		border-radius: 50%;
		box-shadow: 0 8px 10px rgba(56, 163, 253, 0.3);
		cursor: pointer;
		height: 40px;
		width: 40px;
		text-align: center;

		transition: 0.3s;
		-webkit-animation: hoverWave linear 1s infinite;
		animation: hoverWave linear 1s infinite;
		display: flex;
		justify-content: center;
		align-items: center;
		text-decoration: none;
	}

	.btn-call__ico {
		display: flex;
		justify-content: center;
		align-items: center;
		animation: 1200ms ease 0s normal none 1 running shake;
		animation-iteration-count: infinite;
		-webkit-animation: 1200ms ease 0s normal none 1 running shake;
		-webkit-animation-iteration-count: infinite;
		color: white;
		font-size: 30px;
		padding-top: 5px;
		transition: 0.3s all;
	}

	.btn-call:hover {
		background-color: #fff;
	}

	.btn-call:hover .btn-call__ico {
		color: #38a3fd;
	}

	@-webkit-keyframes hoverWave {
		0% {
			box-shadow: 0 8px 10px rgba(56, 163, 253, 0.3), 0 0 0 0 rgba(56, 163, 253, 0.2),
				0 0 0 0 rgba(56, 163, 253, 0.2);
		}

		40% {
			box-shadow: 0 8px 10px rgba(56, 163, 253, 0.3), 0 0 0 15px rgba(56, 163, 253, 0.2),
				0 0 0 0 rgba(56, 163, 253, 0.2);
		}

		80% {
			box-shadow: 0 8px 10px rgba(56, 163, 253, 0.3), 0 0 0 30px rgba(56, 163, 253, 0),
				0 0 0 26.7px rgba(56, 163, 253, 0.067);
		}

		100% {
			box-shadow: 0 8px 10px rgba(56, 163, 253, 0.3), 0 0 0 30px rgba(56, 163, 253, 0),
				0 0 0 40px rgba(56, 163, 253, 0);
		}
	}

	@keyframes hoverWave {
		0% {
			box-shadow: 0 8px 10px rgba(56, 163, 253, 0.3), 0 0 0 0 rgba(56, 163, 253, 0.2),
				0 0 0 0 rgba(56, 163, 253, 0.2);
		}

		40% {
			box-shadow: 0 8px 10px rgba(56, 163, 253, 0.3), 0 0 0 15px rgba(56, 163, 253, 0.2),
				0 0 0 0 rgba(56, 163, 253, 0.2);
		}

		80% {
			box-shadow: 0 8px 10px rgba(56, 163, 253, 0.3), 0 0 0 30px rgba(56, 163, 253, 0),
				0 0 0 26.7px rgba(56, 163, 253, 0.067);
		}

		100% {
			box-shadow: 0 8px 10px rgba(56, 163, 253, 0.3), 0 0 0 30px rgba(56, 163, 253, 0),
				0 0 0 40px rgba(56, 163, 253, 0);
		}
	}

	/* animations icon */

	@keyframes shake {
		0% {
			transform: rotateZ(0deg);
			-ms-transform: rotateZ(0deg);
			-webkit-transform: rotateZ(0deg);
		}

		10% {
			transform: rotateZ(-30deg);
			-ms-transform: rotateZ(-30deg);
			-webkit-transform: rotateZ(-30deg);
		}

		20% {
			transform: rotateZ(15deg);
			-ms-transform: rotateZ(15deg);
			-webkit-transform: rotateZ(15deg);
		}

		30% {
			transform: rotateZ(-10deg);
			-ms-transform: rotateZ(-10deg);
			-webkit-transform: rotateZ(-10deg);
		}

		40% {
			transform: rotateZ(7.5deg);
			-ms-transform: rotateZ(7.5deg);
			-webkit-transform: rotateZ(7.5deg);
		}

		50% {
			transform: rotateZ(-6deg);
			-ms-transform: rotateZ(-6deg);
			-webkit-transform: rotateZ(-6deg);
		}

		60% {
			transform: rotateZ(5deg);
			-ms-transform: rotateZ(5deg);
			-webkit-transform: rotateZ(5deg);
		}

		70% {
			transform: rotateZ(-4.28571deg);
			-ms-transform: rotateZ(-4.28571deg);
			-webkit-transform: rotateZ(-4.28571deg);
		}

		80% {
			transform: rotateZ(3.75deg);
			-ms-transform: rotateZ(3.75deg);
			-webkit-transform: rotateZ(3.75deg);
		}

		90% {
			transform: rotateZ(-3.33333deg);
			-ms-transform: rotateZ(-3.33333deg);
			-webkit-transform: rotateZ(-3.33333deg);
		}

		100% {
			transform: rotateZ(0deg);
			-ms-transform: rotateZ(0deg);
			-webkit-transform: rotateZ(0deg);
		}
	}

	@-webkit-keyframes shake {
		0% {
			transform: rotateZ(0deg);
			-ms-transform: rotateZ(0deg);
			-webkit-transform: rotateZ(0deg);
		}

		10% {
			transform: rotateZ(-30deg);
			-ms-transform: rotateZ(-30deg);
			-webkit-transform: rotateZ(-30deg);
		}

		20% {
			transform: rotateZ(15deg);
			-ms-transform: rotateZ(15deg);
			-webkit-transform: rotateZ(15deg);
		}

		30% {
			transform: rotateZ(-10deg);
			-ms-transform: rotateZ(-10deg);
			-webkit-transform: rotateZ(-10deg);
		}

		40% {
			transform: rotateZ(7.5deg);
			-ms-transform: rotateZ(7.5deg);
			-webkit-transform: rotateZ(7.5deg);
		}

		50% {
			transform: rotateZ(-6deg);
			-ms-transform: rotateZ(-6deg);
			-webkit-transform: rotateZ(-6deg);
		}

		60% {
			transform: rotateZ(5deg);
			-ms-transform: rotateZ(5deg);
			-webkit-transform: rotateZ(5deg);
		}

		70% {
			transform: rotateZ(-4.28571deg);
			-ms-transform: rotateZ(-4.28571deg);
			-webkit-transform: rotateZ(-4.28571deg);
		}

		80% {
			transform: rotateZ(3.75deg);
			-ms-transform: rotateZ(3.75deg);
			-webkit-transform: rotateZ(3.75deg);
		}

		90% {
			transform: rotateZ(-3.33333deg);
			-ms-transform: rotateZ(-3.33333deg);
			-webkit-transform: rotateZ(-3.33333deg);
		}

		100% {
			transform: rotateZ(0deg);
			-ms-transform: rotateZ(0deg);
			-webkit-transform: rotateZ(0deg);
		}
	}
</style>
